module.exports = __webpack_public_path__ + "static/media/classic.14f37604.jpg";